import { Pipe, PipeTransform } from '@angular/core';
import {
  HolidayTypeEnum,
  HolidayTypeInfo,
} from '../../../holidays/types/holiday-type.enum';

@Pipe({
  name: 'holidayType',
  standalone: false,
})
export class HolidayTypePipe implements PipeTransform {
  transform(value: HolidayTypeEnum): string {
    if (value && Object.prototype.hasOwnProperty.call(HolidayTypeInfo, value)) {
      return HolidayTypeInfo[value].name;
    }

    return value;
  }
}
